import t_12_2512 from './KZ.Т.12.2512.svg'
import t_12_2512_b from './KZ.Т.12.2512 black.svg'

export default [
  t_12_2512,
  t_12_2512_b
]
